"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const QButton_1 = __importDefault(require("components/QButton"));
const core_1 = require("companion-app-components/utils/core");
const Win_png_1 = __importDefault(require("assets/setup-page/Win.png"));
const Mac_png_1 = __importDefault(require("assets/setup-page/Mac.png"));
const Mac_Icon_png_1 = __importDefault(require("assets/setup-page/Mac Icon.png"));
const Win_Icon_png_1 = __importDefault(require("assets/setup-page/Win Icon.png"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const utils_1 = require("utils/utils");
const styles_1 = __importDefault(require("./styles"));
const WIDTH_DEFINED = 891;
const log = (0, core_1.getLogger)('containers/SetupPageWebFirst');
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const SetupPageWebFirst = ({ profile, authSession, defaultTabIsWindows, onCreateDataset, }) => {
    const { classes } = useStyles();
    const [isWindows, setIsWondows] = (0, react_1.useState)(defaultTabIsWindows !== undefined ? defaultTabIsWindows : !(0, utils_1.isMac)());
    const prevDefaultTabIsWindows = (0, react_use_1.usePrevious)(defaultTabIsWindows);
    const userEmail = (0, utils_1.safeRefIn)(profile, ['primaryEmail', 'address']) || '';
    const macDownload = `https://download.quicken.com/mac/Quicken.dmg?email=${userEmail}`;
    const winDownload = `https://download.quicken.com/windows/Quicken.exe?email=${userEmail}`;
    const downloadLink = isWindows ? winDownload : macDownload;
    const stepsImg = isWindows ? Win_png_1.default : Mac_png_1.default;
    const suffix = isWindows ? 'for Windows' : 'Mac';
    const selectTab = (argIsWindows) => {
        setIsWondows(argIsWindows);
    };
    (0, react_1.useEffect)(() => {
        if (prevDefaultTabIsWindows !== defaultTabIsWindows) {
            setIsWondows(defaultTabIsWindows !== undefined ? defaultTabIsWindows : !(0, utils_1.isMac)());
        }
    }, [prevDefaultTabIsWindows, defaultTabIsWindows]);
    return (<Box_1.default display="flex" height="100%">
      <Box_1.default m="auto" maxWidth={WIDTH_DEFINED}>
        <Typography_1.default className={classes.title}>
          Hello.
        </Typography_1.default>
        <Typography_1.default className={classes.subTitle}>
          Welcome to Quicken!
        </Typography_1.default>
        <Typography_1.default className={classes.bodyText}>
          {'You can start on the web, and stay on the web (and mobile), but if you want to explore the full features on Quicken Desktop '}
          {'you will eventually want to sync your data into the desktop app.  We need to know which version you plan on using'}
        </Typography_1.default>
        <Box_1.default width={WIDTH_DEFINED} ml="auto" mr="auto">
          <div className={classes.choiceTabs}>
            <ButtonBase_1.default className={(0, classnames_1.default)(classes.tab, isWindows ? 'selected' : 'unselected')} onClick={() => selectTab(true)}>
              <div>
                <img alt="Windows Icon" src={Win_Icon_png_1.default} className={classes.imgIcon}/>
                <Typography_1.default display="inline">
                  WINDOWS
                </Typography_1.default>
              </div>
            </ButtonBase_1.default>
            <ButtonBase_1.default className={(0, classnames_1.default)(classes.tab, isWindows ? 'unselected' : 'selected')} onClick={() => selectTab(false)}>
              <div>
                <img alt="Mac icon" src={Mac_Icon_png_1.default} className={classes.imgIcon}/>
                <Typography_1.default display="inline">
                  MAC
                </Typography_1.default>
              </div>
            </ButtonBase_1.default>
          </div>
          <Box_1.default id="content" ml={15} width="auto">
            <Box_1.default mt={15}>
              <img alt="graphical steps" src={stepsImg}/>
            </Box_1.default>
            <div className={classes.footer}>
              <Divider_1.default sx={{ mb: 10 }}/>
              <div className={classes.bodyText}>
                <Link_1.default className={classes.link} onClick={() => window.open('https://www.quicken.com/support/quicken-web-frequently-asked-questions', '_blank')}>
                  See this FAQ,
                </Link_1.default>
                {' on how to set your accounts up for Sync'}
                <div className={classes.vertBar}/>
                <Link_1.default className={classes.link} onClick={() => window.open(`https://www.quicken.com/my-account?bearer=${authSession.accessToken}`, '_blank')}>
                  Go to My Account
                </Link_1.default>
                <div className={classes.vertBar}/>
                <Link_1.default className={classes.link} onClick={() => {
            log.log(`Opening: ${downloadLink}`);
            window.open(downloadLink, '_blank');
        }}>
                  {`Download Quicken for ${isWindows ? 'Windows' : 'Mac'}`}
                </Link_1.default>
              </div>
              <div className={classes.startClean}>
                <QTip_1.default title={`Creates a new cloud file that you can use on web and mobile, and then load into a new Quicken ${suffix} file when you want to use the desktop`}>
                  <QButton_1.default onClick={() => onCreateDataset(isWindows ? 'quicken_windows' : 'quicken_mac')}>
                    {`Create New Quicken ${suffix} Dataset`}
                  </QButton_1.default>
                </QTip_1.default>
              </div>
            </div>
          </Box_1.default>
        </Box_1.default>
      </Box_1.default>
    </Box_1.default>);
};
exports.default = (0, react_1.memo)(SetupPageWebFirst);
